module.exports = __webpack_public_path__ + "templates.category_filter_button-2f3932ce.html";